import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';

export default function RouteErrorBoundary(
  props: React.ComponentProps<typeof ErrorBoundary>
) {
  const { pathname, search } = useLocation();
  return <ErrorBoundary key={pathname + search} {...props} />;
}
